import React from 'react'
import "./css/common.css"


export default function StatisticalAnalysisTab(props) {
        return (
                <div className="main_tab scrollbar_property">
                        STATISTICAL ANALYSIS
                        <br></br>
                        {props.selected_dataset}
                </div>
        )
}
